import { MediaGalleryItem } from './MediaGalleryItem';
import { GalleryView } from './GalleryView';

type MediaGalleryProps = {
  channelGuid: string;
  standalone?: boolean;
};

export const MediaGallery = (props: MediaGalleryProps) => {
  const { channelGuid, standalone } = props;
  return (
    <GalleryView
      channelGuid={channelGuid}
      fileUploadType='MEDIA'
      columnQuery={{
        sm: [800, 2],
        md: [1000, standalone ? 2 : 3],
        lg: [1200, standalone ? 2 : 4],
        xl: [1500, standalone ? 2 : 5],
      }}
      timeStyle={{ pl: 5 }}
      itemBuilder={(message) => (
        <MediaGalleryItem key={message.guid} message={message} />
      )}
    />
  );
};
